import { useEffect } from 'react';

import { useNotifications, useLocation, useNavigate } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

const useRedirectNotifications = () => {
  const navigate = useNavigate();
  const location = useLocation<LocationStateType['wallets']>();
  const { state } = location;

  const {
    bindCardFailedNotification,
    bindCarsSuccessNotification,
    buySuccessNotification,
    buyErrorNotification,
  } = useNotifications();

  useEffect(() => {
    switch (true) {
      case !!state?.buySuccessNotification:
        buySuccessNotification(state.buySuccessNotification);
        break;
      case state?.buyErrorNotification:
        buyErrorNotification();
        break;
      case state?.bindCarsSuccessNotification:
        bindCarsSuccessNotification();
        break;
      case state?.bindCardFailedNotification:
        bindCardFailedNotification();
        break;
      default:
        break;
    }
    navigate<'wallets'>(CONST.nav.wallets, { state: { cacheConverter: state?.cacheConverter } });
  }, []);
};

export default useRedirectNotifications;
